export { default as myCourseService } from './my-course-service'
